
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M13.955 1l4.5 4v14h-13.5v-3h1.5v1.5h10.5v-11h-4v-4h-6.5V7h-1.5V1h9zm-.44 7.5c.669 0 1.376.256 1.881.762l-.691.87c-.381-.287-.739-.443-1.19-.443-.427 0-.691.171-.691.482 0 .319.365.443.878.645l.723.288c.715.287 1.142.77 1.142 1.585 0 .964-.808 1.811-2.207 1.811-.754 0-1.562-.28-2.16-.832l.784-.956c.412.35.949.591 1.407.591.513 0 .754-.194.754-.505 0-.334-.319-.443-.816-.653l-.738-.31c-.607-.242-1.174-.747-1.174-1.586 0-.972.87-1.749 2.099-1.749zM3.14 8.609l.466 1.033c.125.273.257.576.42.949h.031c.132-.373.256-.676.373-.949l.42-1.033h1.469l-1.493 2.868L6.42 14.39H4.873l-.536-1.127c-.14-.303-.272-.606-.428-.963h-.03c-.14.357-.265.66-.397.963l-.498 1.127H1.5l1.593-2.976-1.5-2.806H3.14zm5.433 0v4.616h2.246v1.166H7.18V8.61h1.392z"}})])
          )
        }
      }
    